import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import AccountDetail from './AccountDetail';
import AccountOrganisations from './AccountOrganisations';
import AccountUsers from './AccountUsers';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;

const Index = () => {
  const { schema } = useEntitySchema(entityNames.ACCOUNT);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.ACCOUNT}
      screenQueryName={EDetailsQueryNames.GetAccountDetails}
      entityId={+id}
      title={data => `Account #${data?.id}`}
      cancelLink={AppRoutes.AccountList}
    >
      <AccountDetail schema={schema} />
      <AccountOrganisations id={+id} />
      <AccountUsers id={+id} />
    </S9CustomEntityFormPage>
  );
};
export default Index;
